import { angularInjectorProvider } from 'Injector';
import { type ErrorLogService } from './ErrorLogService';

export function useErrorLogService() {
    return angularInjectorProvider.get<typeof ErrorLogService>('ErrorLogService');
}
